// extracted by mini-css-extract-plugin
export default {"cart":"CartBlock_cart__Sag1M","sum":"CartBlock_sum__9sJhP","count":"CartBlock_count__tQ+Bf","icon":"CartBlock_icon__SEwSf"};